import rawMotions from './gestureMotions.json';
import { WALKING_MOTION_NUMBERS } from './walkingMotions';

export type GestureMotionConfig = {
  id: string;
  label: string;
};

const normalizeGestureMotions = (value: GestureMotionConfig[]) =>
  value
    .filter((item) => item && typeof item.id === 'string' && typeof item.label === 'string')
    .filter((item) => !WALKING_MOTION_NUMBERS.has(Number(item.id)))
    .map((item) => ({ id: item.id, label: item.label }));

export const GESTURE_MOTIONS: GestureMotionConfig[] = normalizeGestureMotions(rawMotions as GestureMotionConfig[]);

export const DEFAULT_GESTURE_MOTION_ID = GESTURE_MOTIONS[0]?.id ?? '';

export const getGestureLabel = (id?: string) =>
  GESTURE_MOTIONS.find((motion) => motion.id === id)?.label;
